export enum PolicyComplianceValue {
  FAILED = "failed",
  PASSED = "passed",
}

export enum HostActivityType {
  HOST_LOGIN = "host_login",
  HOST_LOGOUT = "host_logout",
  HOST_REMOTE = "host_remote",
  HOST_VPN_ENABLED = "host_vpn_enabled",
  HOST_VPN_DISABLED = "host_vpn_disabled",
  HOST_SHUTDOWN = "host_shutdown",
  HOST_RESTART = "host_restart",
  HOST_UNINSTALL = "host_uninstall",
}
